import React from "react";
const MessageLoadingModal = (props) => {
  return (
    <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content" style={{ gap: 50 }}>
          <div className="modal__header">
            <div
              className="loader__container"
              style={{ width: 60, height: 60 }}
            >
              <div className="spinner" style={{ width: 45, height: 45 }}></div>
            </div>
          </div>
          <div className="modal__body">
            <h4 className="promptMessage" style={{whiteSpace: "pre-line"}}>{props.message}</h4>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default MessageLoadingModal;
